import { CITIZEN_INITIAL_FILTER_FIELDS } from '../citizens'

export const UNIFIED_PERSON_INITIAL_FILTER_FIELDS = CITIZEN_INITIAL_FILTER_FIELDS